import { lightTheme, darkTheme } from '../styles/theme';

export const getModalThemeStyles = (isDarkMode) => {
  const theme = isDarkMode ? darkTheme : lightTheme;
  
  return {
    '--bg-color': theme.colors['background-primary'],
    '--border-color': theme.colors['border-color'],
    '--text-color': theme.colors['text-primary'],
    '--section-bg': theme.colors['background-secondary']
  };
};